import type { WelcomeMessage } from '@/modules/creator-settings/types.ts'
import { toPlural } from '@/utils/helpers.ts'

export const generateWelcomeTableOptions = (
  message: WelcomeMessage['statistics'],
) => {
  return {
    title: 'Welcome Messages',
    rows: [
      {
        label: 'Sent To',
        value: `${message?.totalSent ?? 0} ${toPlural(message?.totalSent, 'Fan')}`,
      },
      {
        label: 'Reads',
        value: `${message?.totalReads ?? 0} ${toPlural(message?.totalReads, 'Fan')}`,
      },
      {
        label: 'Responses',
        value: `${message?.totalResponses ?? 0} ${toPlural(message?.totalResponses, 'Fan')}`,
      },
      {
        label: 'PPV Bought',
        value: `${message?.totalPPVBought ?? 0}`,
      },
    ],
  }
}
